import { render, staticRenderFns } from "./AudienceNotesPanel.vue?vue&type=template&id=f79b6398&scoped=true"
import script from "./AudienceNotesPanel.vue?vue&type=script&lang=js"
export * from "./AudienceNotesPanel.vue?vue&type=script&lang=js"
import style0 from "./AudienceNotesPanel.vue?vue&type=style&index=0&id=f79b6398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79b6398",
  null
  
)

export default component.exports